import { EnumBillingCounter } from '@Model';
import { type SelectOption } from '@synqo/frontend-component-library';

export const invoiceCounterTypes: EnumBillingCounter[] = [
    EnumBillingCounter.Invoice,
    EnumBillingCounter.CreditNote,
    EnumBillingCounter.Cancellation,
    EnumBillingCounter.CashJournal,
    EnumBillingCounter.CashJournalPosition,
    EnumBillingCounter.CashInvoice,
    EnumBillingCounter.CashCreditNote,
    EnumBillingCounter.CashCancellation,
    EnumBillingCounter.DraftInvoice,
];

export function getInvoiceCounterName(counterType: EnumBillingCounter): string {
    switch (counterType) {
        case EnumBillingCounter.Invoice:
            return 'Rechnungszähler';
        case EnumBillingCounter.CreditNote:
            return 'Gutschriftzähler';
        case EnumBillingCounter.Cancellation:
            return 'Stornozähler';
        case EnumBillingCounter.CashJournal:
            return 'Kassenbuch';
        case EnumBillingCounter.CashJournalPosition:
            return 'Kassenbuch-Eintrag';
        case EnumBillingCounter.CashInvoice:
            return 'Barrechnungszähler';
        case EnumBillingCounter.CashCreditNote:
            return 'Bargutschriftzähler';
        case EnumBillingCounter.CashCancellation:
            return 'Barstornozähler';
        case EnumBillingCounter.DraftInvoice:
            return 'Testrechnungszähler';
    }
}

export const invoiceCounterTypesItems: SelectOption<EnumBillingCounter>[] = invoiceCounterTypes.map((counterType) => ({
    name: getInvoiceCounterName(counterType),
    value: counterType,
    label: getInvoiceCounterName(counterType),
}));
